module.exports = __webpack_public_path__ + "static/media/Seoul.64f0f0c2.jpg";